import { useState } from 'react'
import { Link } from 'react-router-dom'
import HeroCTA from '../components/HeroCTA'
import TestimonialSlider from '../components/TestimonialSlider'
import { projects } from '../data/projects'
import './CompletedProjectsPage.css'

function CompletedProjectsPage() {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const categories = ['All', 'Medical', 'Education', 'Research', 'Industrial', 'Efficiency Audit']
  
  const filteredProjects = selectedCategory === 'All' || selectedCategory === null
    ? projects
    : projects.filter(project => project.category === selectedCategory)

  return (
    <div className="former-projects-page">
      <section className="page-hero">
        <div className="container">
          <h1>Completed Projects</h1>
          <p className="page-hero-subtitle">
            Explore our portfolio of successful laboratory installations and see how we've helped 
            businesses and universities create exactly the lab they need.
          </p>
        </div>
      </section>

      <section className="projects-content">
        <div className="container">
          {/* Filter Buttons */}
          <div className="projects-filters">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-button ${selectedCategory === category || (category === 'All' && selectedCategory === null) ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category === 'All' ? null : category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Projects Gallery */}
          <div id="gallery" className="projects-gallery">
            {filteredProjects.map((project) => (
              <Link key={project.id} to={`/projects/${project.id}`} className="project-card">
                <div className="project-image-wrapper">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                    loading="lazy"
                  />
                  <div className="project-overlay">
                    <span className="project-category">{project.category}</span>
                    <span className="project-year">{project.year}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
              </Link>
            ))}
          </div>

          {filteredProjects.length === 0 && (
            <div className="no-projects">
              <p>No projects found in this category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="projects-testimonials">
        <div className="container">
          <h2 className="section-title">Client Testimonials</h2>
          <p className="section-subtitle">
            Hear from our satisfied clients about their experience working with us
          </p>
          <TestimonialSlider />
        </div>
      </section>

      {/* CTA Section */}
      <section className="projects-cta-section">
        <div className="container">
          <div className="projects-cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>
              Let us help you create exactly the lab you need. Our team brings extensive parts 
              knowledge and service expertise to every project.
            </p>
            <HeroCTA />
          </div>
        </div>
      </section>
    </div>
  )
}

export default CompletedProjectsPage
